import { useParamsSearch } from '@anytag/shared-hooks';
import { TikTokCampaignInfluencersSearchType } from '../schemaTypes';

export const useTikTokCampaignInfluencersFilter = () => useParamsSearch<TikTokCampaignInfluencersSearchType>();
